import { APOffer } from "@/apps/tatar/activityApp/views/details/offer-feature/APOffer.Interface";
import React from "react";
import useVacancyContractDetailsActions from "../useVacancyContractDetailsActions";
import { APOfferVacancyMeta } from "../../../../model/VacancyApplicant.interface";
import { useTypedSelector } from "@/redux/hooks";
import i18n from "@/i18n";
import AssignmentLabel from "@/components/AssignmentLabel/AssignmentLabel";
import VacancyContractSignChangeButton from "./VacancyContractSignChangeButton";
import { APActivity } from "@/apps/tatar/activityApp/ActivityInterfaces";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";

type Props = {
  offer: APOffer;
  activity: APActivity;
  onSign: () => void;
  reload?: () => void;
};

const VacancyContractSignButton = (props: Props) => {
  const { offer, activity, reload, onSign } = props;
  const { digitalRentalAgreementSigners } = useVacancyContractDetailsActions();
  const userId = useTypedSelector((state) => state.global.user._id);

  const offerMeta = offer.data.meta as APOfferVacancyMeta;

  const assignedUserId = offerMeta?.contractData?.landLordSignerId;

  const isSigner = userId === assignedUserId;
  const isSignerConfigured = digitalRentalAgreementSigners.some((s) => {
    return s.userId === assignedUserId;
  });

  const renderCurrentSigner = () => {
    return (
      <div className="margin-top-10 __grid-cols-2 __grid">
        <div>
          <div>
            {i18n.t(
              "apTemplate:Vacancy.Applicant.VacancyContractSignButton.AssignedSigner",
              "Aktueller Unterzeichner:"
            )}
          </div>
          <AssignmentLabel users={[assignedUserId]} teams={[]} />
        </div>
        <div>
          <VacancyContractSignChangeButton
            activity={activity}
            offer={offer}
            reload={reload}
          />
        </div>
      </div>
    );
  };

  if (!isSignerConfigured) {
    return (
      <div>
        <div className="__sub-text">
          {i18n.t(
            "apTemplate:Vacancy.Applicant.VacancyContractSignButton.SignerNotConfigured",
            "Der Unterzeichner ist nicht konfiguriert."
          )}
        </div>
        {renderCurrentSigner()}
      </div>
    );
  }

  if (!isSigner) {
    return (
      <div>
        <div className="__sub-text">
          {i18n.t(
            "apTemplate:Vacancy.Applicant.VacancyContractSignButton.NotSigner",
            "Sie sind nicht als Unterzeichner für diesen Mietvertrag eingetragen."
          )}
        </div>
        {renderCurrentSigner()}
      </div>
    );
  }

  return (
    <div className="margin-top-10 __grid-cols-2 __grid">
      <div>
        <BFButton appearance="link" onClick={onSign}>
          {i18n.t(
            "apTemplate:Vacancy.Applicant.ContractDetails.Label.OfferAccepted.SignAndCloseContract",
            "Mietvertrag unterschreiben und abschließen"
          )}
        </BFButton>
      </div>
      <div>
        <VacancyContractSignChangeButton
          activity={activity}
          offer={offer}
          reload={reload}
        />
      </div>
    </div>
  );
};

export default VacancyContractSignButton;
